/**
 * Sidebar arama eşleşmesi — aksan/diakritik duyarsız, Türkçe küçük harf kurallı
 * (İ→i, I→ı). Grup adı + öğe etiketine karşı alt-dize araması.
 */

const COMBINING_MARKS = /[̀-ͯ]/g;

/** Türkçe küçük harfe indir + birleşik işaretleri (aksan) sök. */
export function normalizeForSearch(value: string): string {
  return value.toLocaleLowerCase('tr').normalize('NFD').replace(COMBINING_MARKS, '').trim();
}

/** `query` boşsa her zaman eşleşir. Aksi hâlde normalize edilmiş `query`, verilen
 *  metinlerden herhangi birinin içinde alt-dize olarak geçiyorsa eşleşir. */
export function menuItemMatchesQuery(query: string, ...texts: (string | undefined)[]): boolean {
  const q = normalizeForSearch(query);
  if (!q) return true;
  return texts.some((t) => t != null && normalizeForSearch(t).includes(q));
}
